// extracted by mini-css-extract-plugin
export default {"doubleSpace":"overview-module__doubleSpace--mEjPO","hhsMobileWrapReverse":"overview-module__hhsMobileWrapReverse--TOVOQ"};